import React, {Component} from 'react';
import { withRouter } from 'react-router-dom'
import PropTypes from "prop-types";

import Icon from "../Icon";
import Api from "../../api/Api";
import Loader from "../Loader";

const qs = require("qs");

class SocialLogin extends Component {
  static propTypes = {
    type: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      loading: false
    }
  }


  onOauthOutClick() {
    localStorage.setItem("return_url", window.location.pathname);

    let params = Api.defaultParams();
    params.return_host = window.location.origin;

    this.setState({
      loading: true
    }, () => {
      window.location.href = Api.buildUrl("user/omniauth/" + this.props.type + "?" + qs.stringify(params));
    })
  }

  render() {
    const { type } = this.props;

    return (
      <div>
        {this.state.loading && <Loader overlay={true} />}
        <button onClick={this.onOauthOutClick.bind(this)} className={'social-login'}>
          <div className={'social-icon social-icon-' + type}>
            <Icon icon={["fab", type]}/>
          </div>
        </button>
      </div>
    );
  }
}

export default withRouter(SocialLogin);